import { Badge, Tooltip, TooltipTrigger, TooltipContent } from '@bliks-io/ui';

interface HomeOrgDeletedBadgeProps {
  label: string;
  tooltip: string;
}

/**
 * Red warning badge for users whose pinned home organization was soft-deleted
 * (sign-in is, or will be, blocked). Shared by the superadmin tenant users
 * table and the tenant org-members list, which differ only in i18n copy.
 */
export function HomeOrgDeletedBadge({ label, tooltip }: HomeOrgDeletedBadgeProps) {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        {/* Badge renders a div — tabIndex makes the tooltip keyboard-reachable. */}
        <Badge colorScheme="error" tabIndex={0}>
          {label}
        </Badge>
      </TooltipTrigger>
      <TooltipContent className="max-w-xs">{tooltip}</TooltipContent>
    </Tooltip>
  );
}
